import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, } from '@angular/router';
import { SharedService } from './shared.service';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private router: Router, private sharedService: SharedService) {
  }
  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (state.url.split('/')[1] !== 'invoices') {
      if (this.sharedService.getPermissions(state.url.split('/')[1])) {
        return true;
      } else if (state.url.split('/')[1].includes('users') && this.sharedService.getPermissions('users')) {
        return true;
      } else if (state.url.split('/')[1] == 'admin' && this.sharedService.getPermissions('admin_dashboard')) {
        return true;
      }
    } else {
      if (state.url.split('/')[2] == 'complete' && this.sharedService.getPermissions('completedmoves')) {
        return true;
      } else if (state.url.split('/')[2] == 'active' && this.sharedService.getPermissions('invoices')) {
        return true;
      } else if (state.url.split('/')[2] == 'ready_to_audit' && this.sharedService.getPermissions('ready_to_audit')) {
        return true;
      }
    }

    this.router.navigateByUrl('/orders');
    return true;
  }
}
